module.exports = __webpack_public_path__ + "assets/icon-search-gray.f5c00fea.svg";